import { message, notification } from 'antd';
import React, { HTMLAttributes, HTMLProps, useCallback, useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { LoadingOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { errorParse } from 'utils';

interface CptTypes {
  children?: React.ReactNode;
  className?: string;
  onClick?: (arg?: any) => any;
  loading?: boolean;
  link?: string;
  style?: React.CSSProperties;
  disabled?: boolean | null;
  disabledClick?: boolean;
  id?: string;
  size?: 'mini';
  type?: 'primary';
}

export const AppButton: React.FC<CptTypes> = React.memo((props) => {
  props = { ...props };
  const [loadingTemp, _loading] = useState(false);
  const loading = props.loading || loadingTemp;

  const onClick = useCallback(async () => {
    if (loading) return;
    if (props.disabled && props.disabledClick !== true) return;
    if (!props.onClick) return;
    _loading(true);
    try {
      await props.onClick();
    } catch (e) {
      console.log('appButton catch', e);
      const tip = errorParse(e);
      if (!tip) return;
      notification.error({ message: 'Error', description: tip });
    } finally {
      _loading(false);
    }
  }, [props.onClick, loading]);

  const linkProps = props.link ? { href: props.link, target: '_blank', rel: 'noreferrer' } : null;

  return (
    <AppButtonStyle
      onClick={onClick}
      {...linkProps}
      style={props.style}
      id={props.id}
      className={classNames(`type-${props.type || 'primary'}`, `size-${props.size}`, { loading, disabled: props.disabled }, props.className)}
    >
      {props.children}
      {loading && <LoadingOutlined />}
    </AppButtonStyle>
  );
});

const ButtonStyle = (props: React.AnchorHTMLAttributes<HTMLAnchorElement> | React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>) => {
  /* eslint-disable jsx-a11y/anchor-has-content */
  if ('href' in props) return <a {...props} />;
  return <div {...(props as any)} />;
};

const AppButtonStyle = styled(ButtonStyle)`
  cursor: pointer;
  position: relative;
  transition: all ease 0.2s;
  user-select: none;
  transition: all 0.2s linear;
  display: flex;
  height: 60px;
  font-size: 20px;
  font-weight: 800;
  color: #000;
  padding: 0 32px;
  border-radius: 100px;
  font-family: Kanit;
  gap: 8px;
  &.type-primary {
    background: linear-gradient(180deg, #fabe4b 0%, #c68200 100%);
    box-shadow: 0 0 1px rgba(255, 255, 255, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &.disabled {
    filter: grayscale(100%);
    cursor: not-allowed;
    pointer-events: none;
  }
  &:hover {
    opacity: 0.8;
    transform: scale(1.05);
    color: #000;
  }
  &.loading {
    cursor: wait;
  }
`;
